import { Check } from './types';
import { FINcredbileReport } from './report';

export function getFincredibleReport(check: Check): FINcredbileReport {
	const reports = check.reports;
	const fincredibleReport = reports.find((report) => report.name === 'FINCREDIBLE');
	if (!fincredibleReport) throw new Error('There is no FINCREDIBLE report available inside check response');
	return fincredibleReport as FINcredbileReport;
}
